import * as React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { IPayment, PaymentTypeIds, TransactionStatus } from '@getgreenline/homi-shared'
import { Modal } from 'antd-v4'
import { WorldpayReceiptList } from './WorldpayReceiptList'
import { CurrentCompanyStore } from '../../stores/CurrentCompanyStore'

interface Props {
  payment: IPayment
}

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}

const _ViewWorldpayTransactionReceiptsButton = ({
  payment,
  currentCompanyStore,
}: Props & InjectedProps) => {
  const company = currentCompanyStore?.company
  const locations = currentCompanyStore?.locations
  const currentLocation = locations?.find((location) => location.id === payment.locationId)
  const worldpayTransactions = payment.transactions.filter((transaction) => {
    return (
      transaction.paymentTypeId === PaymentTypeIds.worldpay &&
      transaction.status === TransactionStatus.COMPLETED
    )
  })

  const [showTransactionReceiptModal, setShowTransactionReceiptModal] = React.useState(false)

  if (!(company && currentLocation)) {
    return <div />
  }

  return (
    <>
      <button className='btn btn-light ml-2' onClick={() => setShowTransactionReceiptModal(true)}>
        View Worldpay receipts
      </button>

      {showTransactionReceiptModal && (
        <Modal
          title='Worldpay receipts'
          visible={showTransactionReceiptModal}
          onCancel={() => setShowTransactionReceiptModal(false)}
          footer={null}
        >
          {worldpayTransactions.length === 0 ? (
            <div className='text-center'>No valid Worldpay transactions found</div>
          ) : (
            worldpayTransactions.map((transaction, index) => (
              <WorldpayReceiptList
                key={transaction.id}
                company={company}
                location={currentLocation}
                transaction={transaction}
                isFirstElement={index === 0}
              />
            ))
          )}
        </Modal>
      )}
    </>
  )
}

export const ViewWorldpayTransactionReceiptsButton = inject('currentCompanyStore')(
  observer(_ViewWorldpayTransactionReceiptsButton),
)
